(() => {
  const scopeSelector = '[data-sv-product-description]';
  const inlineSelector = 'a,b,strong,em,i,span,small,sup,sub';

  function splitBenefits(paragraph) {
    if (paragraph.querySelector('.sv-description-benefit')) return;
    const segments = [[]];
    for (const node of paragraph.childNodes) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        if (node.attributes.length) return;
        segments.push([]);
      } else {
        if (node.nodeType !== Node.TEXT_NODE) {
          if (node.nodeType !== Node.ELEMENT_NODE || !node.matches(inlineSelector)) return;
          if ([...node.querySelectorAll('*')].some(child => !child.matches(inlineSelector))) return;
        }
        segments[segments.length - 1].push(node);
      }
    }
    if (segments.length < 2 || segments.some(nodes => !/^✓\s+\S/u.test(nodes.map(node => node.textContent).join('').trim()))) return;
    const lines = segments.map(nodes => {
      const line = document.createElement('span');
      line.className = 'sv-description-benefit';
      line.append(...nodes);
      return line;
    });
    paragraph.replaceChildren(...lines);
  }

  function markIngredients(scope) {
    scope.querySelectorAll('p,h2,h3,h4,h5,h6').forEach(heading => {
      if (heading.closest(scopeSelector) !== scope) return;
      if (!/^key ingredients\s*:?$/i.test(heading.textContent.trim())) return;
      if (heading.matches('p') && !heading.querySelector('strong,b')) return;
      let list = heading.nextElementSibling;
      while (list && list.matches('p') && !list.children.length && !list.textContent.trim()) {
        list = list.nextElementSibling;
      }
      if (list && list.matches('ul') && [...list.children].every(child => child.matches('li'))) {
        list.classList.add('sv-description-key-ingredients');
      }
    });
  }

  function enhance(root) {
    if (!document.body.matches('.templateProduct')) return;
    const scopes = [...root.querySelectorAll(scopeSelector)];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(scopeSelector)) scopes.unshift(root);
    scopes.forEach(scope => {
      scope.querySelectorAll('p').forEach(paragraph => {
        if (paragraph.closest(scopeSelector) === scope) splitBenefits(paragraph);
      });
      markIngredients(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
